import { createReducer, on } from '@ngrx/store';
import { MultiAssessmentState } from './multi-assessment.state';
import * as MultiAssessmentActions from './multi-assessment.actions';

import { normalizeConfig } from 'src/app/shared/utils/assessment-navigator';

export const initialMultiAssessmentState: MultiAssessmentState = {
  selectedAssessment: null,
  student: null,
  sectionIds: null,
};

export const multiAssessmentReducer = createReducer(
  initialMultiAssessmentState,

  on(MultiAssessmentActions.setMultiAssessment, (state, { assessment }) => ({
    ...state,
    selectedAssessment: assessment ? normalizeConfig(assessment) : null,
  })),

  on(
    MultiAssessmentActions.setMultiAssessmentStudent,
    (state, { student }) => {
      const isSameStudent =
        state.student && student && state.student.id === student.id;
      const resolvedSectionIds =
        student?.sectionIds !== undefined
          ? student.sectionIds
          : isSameStudent
          ? (state.sectionIds ?? null)
          : null;

      return {
        ...state,
        student: student
          ? { ...student, sectionIds: resolvedSectionIds }
          : null,
        sectionIds: resolvedSectionIds,
      };
    }
  ),

  on(
    MultiAssessmentActions.setMultiAssessmentSectionIds,
    (state, { sectionIds }) => ({
      ...state,
      sectionIds,
      student: state.student ? { ...state.student, sectionIds } : null,
    })
  ),

  on(
    MultiAssessmentActions.resetMultiAssessment,
    () => initialMultiAssessmentState
  )
);
